import styled from "styled-components";

export const FavoritesContainer = styled.div`
    display: flex;
    width: 100%;
    height: 100%;
    flex-direction: column;
`
export const ButtonHeader = styled.div`
    display: flex;
    width: 100%;
    height: 70px;
    justify-content: space-between;
`
export const FavoriteButton = styled.div<{isOpen: boolean}>`
    display: flex;
    justify-content: center;
    align-items: center;
    //background: #ffffff05;
    background: #ffffff05;
    border: 1px solid ${({isOpen}) => isOpen ? '#23AF91' :  '#ffffff10'};;
    color: ${({isOpen}) => isOpen ? '#23AF91' :  '#929AA5'};
    border-radius: 14px;
    font-size: 10px;
    letter-spacing: 2px;
    cursor: pointer;
    width: 160px;
    height: 48px;
`
export const DeleteButton = styled(FavoriteButton)<{isOpen: boolean}>`
    background: #ff000005;
    border: 1px solid ${({isOpen}) => isOpen ? '#FF5E66' :  '#ff000010'};;
    color: #FF5E66;
`
export const MainContainer = styled.div`
    display: flex;
    flex-direction: column;
    overflow-y: scroll;
    width: 100%;
    ::-webkit-scrollbar {
        width: 0;
        display: none;
    }
`
export const FavoritesDeletedRow = styled.div`
    display: flex;
    height: 80px;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    color: white;
    border-bottom: 1px solid #ffffff05;
`
export const PriceContainer = styled.div<{isFav: boolean}>`
    display: flex;
    justify-content: end;
    align-items: center;
    height: 100%;
    & > div{
        width: 40px;
        height: 40px;
        display: flex;
        justify-content: center;
        align-items: center;
        border: 1px solid #ffffff10;
        border-radius: 14px;
        background: #ffffff05;
        cursor: pointer;
        & > svg {
            width: 18px;
            height: 18px;
            stroke: ${({isFav}) => isFav ? '#23AF91' : '#FF5E66'};
            fill: ${({isFav}) => isFav ? '#23AF91' : 'none'};
        }
    }
    & > span {
        margin-left: 12px;
    }
    
`
export const FavDelExchangeIcon = styled.div<{$src: string}>`
    width: 26px;
    height: 26px;
    border-radius: 8px;
    background-repeat: no-repeat;
    background-position: center;
    background-image: ${({ $src }) => `url("${$src}")`};
    background-size: contain;
    cursor: pointer;
`

export const ExchangeContainer = styled.div`
    display: flex;
    height: 100%;
    align-items: center;
    font-size: 22px;
    justify-content: end;
    & > div:nth-child(1) {
        margin-right: 8px;
    }
    & > div:nth-child(2) {
        margin-left: 8px;
    }
`